import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "square-stack-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fillRule: "evenodd" },
        React.createElement("path", { d: "M3.75 6.25h8.5a1 1 0 011 1v7a1 1 0 01-1 1h-8.5a1 1 0 01-1-1v-7a1 1 0 011-1z", stroke: "currentColor", strokeWidth: 1.5, fillOpacity: 0.15, strokeLinejoin: "round" }),
        React.createElement("path", { fill: "currentColor", d: "M4 2.75h8a1 1 0 011 1v.5H3v-.5a1 1 0 011-1zM5 0h6a1 1 0 011 1v.5H4V1a1 1 0 011-1z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
